import React, { useRef, useState } from "react";

import { useBreakpoint } from "../../../hooks/useBreakpoint";
import SwiperGallery from "./swiperGallery";

const MobileGallery = ({
  containerClass,
  gallery,
  videoGallery = [],
  programGalleryFeaturedImage = "",
  featuredSingleVideo = "",
  showGalleryNav = true
}) => {
  const breakpoint = useBreakpoint();
  const swiperRef = useRef(null);
  const [, setSwiper] = useState(null);

  const [currentSwiperItem, setCurrentSwiper] = useState(1);

  // console.debug("using mobile gallery");
  return (
    <>
      {breakpoint && breakpoint === "xs" && gallery?.length > 0 && (
        <SwiperGallery
          containerClass={containerClass}
          setSwiper={setSwiper}
          currentSwiperItem={currentSwiperItem}
          setCurrentSwiper={setCurrentSwiper}
          swiperRef={swiperRef}
          gallery={gallery}
          featuredVideoGallery={videoGallery}
          programGalleryFeaturedImage={programGalleryFeaturedImage}
          singleFeaturedVideo={featuredSingleVideo}
          swiperArrowNav={showGalleryNav}
        />
      )}
    </>
  );
};

export default MobileGallery;
